module.exports = __webpack_public_path__ + "static/media/simdustry-logo.181d59c1.png";